import React, { useState, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { fmtDateBoth } from '../utils/dates';
import { fileIcon, humanSize } from '../utils/files';


export default function AttachmentsPanel({ basePath, attachments, onChange, canEdit, hint, emptyText = 'لا توجد مرفقات' }) {
  const { apiUpload, api } = useAuth();
  const toast = useToast();
  const [uploading, setUploading] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef(null);
  const [preview, setPreview] = useState(null); // { url, name }

  const upload = async (files) => {
    if (!files || files.length === 0) return;
    setUploading(true);
    try {
      const fd = new FormData();
      Array.from(files).forEach(f => fd.append('files[]', f));
      await apiUpload(basePath, fd);
      toast.success(`تم رفع ${files.length} ملف`);
      onChange?.();
    } catch (err) {
      toast.error(err.message || 'فشل الرفع');
    } finally {
      setUploading(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    upload(e.dataTransfer.files);
  };

  const remove = async (a) => {
    if (!window.confirm(`حذف "${a.file_name}"؟`)) return;
    try {
      await api(`${basePath}/${a.id}`, { method: 'DELETE' });
      toast.success('تم الحذف');
      onChange?.();
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div className="attachments-panel">
      {canEdit && (
        <div
          className={`attachments-dropzone ${dragOver ? 'drag-over' : ''} ${uploading ? 'uploading' : ''}`}
          onDragOver={e => { e.preventDefault(); setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          onDrop={handleDrop}
          onClick={() => inputRef.current?.click()}
        >
          <input
            type="file"
            ref={inputRef}
            multiple
            style={{ display: 'none' }}
            onChange={e => { upload(e.target.files); e.target.value = ''; }}
          />
          {uploading
            ? '⏳ جاري الرفع...'
            : `📎 ${hint || 'اسحب ملفات هنا أو اضغط للاختيار'} (حتى ٢٠MB لكل ملف)`}
        </div>
      )}

      {attachments?.length > 0 ? (
        <div className="attachments-list">
          {attachments.map(a => {
            const isImage = a.file_type?.startsWith('image/');
            return (
              <div key={a.id} className="attachment-item">
                {isImage ? (
                  <img
                    src={a.file_url}
                    alt={a.file_name}
                    className="attachment-thumb"
                    onClick={() => setPreview({ url: a.file_url, name: a.file_name })}
                  />
                ) : (
                  <div className="attachment-icon">{fileIcon(a.file_type)}</div>
                )}
                <div className="attachment-info">
                  <a href={a.file_url} target="_blank" rel="noreferrer" className="attachment-name">{a.file_name}</a>
                  <div className="attachment-meta">
                    {humanSize(a.file_size)} · {fmtDateBoth(a.created_at)}
                  </div>
                </div>
                {canEdit && (
                  <button className="btn-icon attachment-remove" onClick={() => remove(a)} title="حذف">✕</button>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ color: 'var(--text-faint)', fontSize: 13, textAlign: 'center', padding: 10 }}>
          {emptyText}
        </div>
      )}

      {preview && (
        <div className="modal-overlay" onClick={() => setPreview(null)} style={{ cursor: 'zoom-out' }}>
          <img src={preview.url} alt={preview.name} style={{ maxWidth: '90%', maxHeight: '90%', borderRadius: 8 }} />
        </div>
      )}
    </div>
  );
}
